import BassIcon from '../../icons/BassIcon';
import BrassIcon from '../../icons/BrassIcon';
import DrumsIcon from '../../icons/DrumsIcon';
import GuitarIcon from '../../icons/GuitarIcon';
import OtherInstrumentIcon from '../../icons/OtherInstrumentIcon';
import PercussionIcon from '../../icons/PercussionIcon';
import PianoIcon from '../../icons/PianoIcon';
import StringsIcon from '../../icons/StringsIcon';
import SynthIcon from '../../icons/SynthIcon';
import WoodwindIcon from '../../icons/WoodwindIcon';

/**
 * Same instrument set the rec list uses, so a cue tag in the sidebar shows the
 * icon the user already associates with that instrument elsewhere in the app.
 */
const INSTRUMENT_ICONS = {
    PIANO: PianoIcon,
    GUITAR: GuitarIcon,
    BASS: BassIcon,
    STRINGS: StringsIcon,
    BRASS: BrassIcon,
    WOODWIND: WoodwindIcon,
    SYNTH: SynthIcon,
    DRUMS: DrumsIcon,
    PERCUSSION: PercussionIcon,
    OTHER: OtherInstrumentIcon,
};

export const getInstrumentIcon = (instrument) =>
    INSTRUMENT_ICONS[String(instrument || '').toUpperCase()] || OtherInstrumentIcon;

export default INSTRUMENT_ICONS;
